export default __webpack_public_path__ + "static/media/poster_eventos_mobile_1000.bed2d950.webp";